import { useLocation } from 'react-router-dom'

export const useSearchParams = (): URLSearchParams => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)

  return params
}
